import EntityTypeEnum from 'common/enums/entityTypeEnum'
import EntityInterface, {
  MasterBlockId,
} from 'common/types/entities/EntityInterface'
import {
  generateHtmlAttrId,
  generateId,
} from 'src/shared/entities/utils/generate-base-entity'

export function createOrderSummary(
  parentId: string,
  masterBlockId?: MasterBlockId,
): EntityInterface {
  return {
    id: generateId(),
    type: EntityTypeEnum.OrderSummary,
    parentId: parentId,
    masterBlockId: masterBlockId,
    margin: {
      marginTop: 0,
      marginRight: 0,
      marginBottom: 0,
      marginLeft: 0,
    },
    mobileMargin: {
      marginTop: 0,
      marginRight: 0,
      marginBottom: 0,
      marginLeft: 0,
    },
    appearance: {
      desktop: true,
      mobile: true,
    },
    htmlAttrId: generateHtmlAttrId(EntityTypeEnum.OrderSummary),
  }
}
